import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import store from "@/store";

// pages
import error from "@/pages/error.vue";
import index from "@/pages/index/index.vue";
import login from "@/pages/login/index.vue";
import loginReset from "@/pages/login/reset.vue";

import cart from "@/pages/cart/index.vue";
import orders from "@/pages/orders/index.vue"
import order from "@/pages/order/index.vue";
import news from "@/pages/news/index.vue";
import page from "@/pages/page.vue";

const routes = [
	{path: "/", name: "products", component: index, meta: {layout: "main", title: "Produkter"}},
	{path: "/login", name: "login", component: login, meta: {auth: false, title: "Login"}},
	{path: "/login/reset/:id", name: "login-reset", component: loginReset, meta: {auth: false, title: "Reset password"}},

	{path: "/cart", name: "cart", component: cart, meta: {layout: "main", title: "Kurv"}},
	{path: "/orders", name: "orders", component: orders, meta: {layout: "main", title: "Ordrehistorik"}},
	{path: "/orders/:id", name: "order", component: order, meta: {layout: "main"}},
	{path: "/news", name: "news", component: news, meta: {layout: "main", title: "Nyheder"}},

	{path: "/contact", name: "contact", component: page, meta: {layout: "main", slug: "kontakt"}},

	{path: "/error", alias: "*", name: "error", props: true, component: error, meta: {auth: false, title: "Error"}}
];

const router = new Router({
	routes,
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {x: 0, y: 0}
		}
	}
});

const go = ({to, next}) => {
	if (to.meta.title) store.dispatch("base/meta", {title: to.meta.title});
	next();
};

router.beforeEach(async (to, from, next) => {
	if (to.name === "error") return go({to, next});

	// allow all routes that isn't protected by auth
	if (to.meta.auth === false) return go({to, next});

	const user = store.getters["user/data"] || await store.dispatch("user/data");

	if (!user) return store.dispatch("user/logout");

	go({to, next});
});

export default router;
